import {
	useGetOnboardingState,
	deserializeState,
} from '@confluence/onboarding-helpers/entry-points/hooks/useOnboardingState/onboardingState.ts';
import { LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA } from '@confluence/onboarding-helpers/entry-points/constants/onboarding-state-constants.ts';
import { useIsLicensed } from '@confluence/session-data/entry-points/useAccessStatus.ts';
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop-utils/entry-points/ApolloErrorInterop.ts';

import { isWithinLastWeek } from '../utils/isWithinLastWeek.ts';

export const useShouldShowNewUserTemplates = ():
	| {
			showNewUserTemplates: boolean;
			loading: boolean;
			error?: undefined;
	  }
	| {
			showNewUserTemplates: boolean;
			loading: boolean;
			error: ApolloErrorInterop;
	  } => {
	const isLicensed = useIsLicensed();

	const { data, loading, error } = useGetOnboardingState(
		Object.values(LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA),
		!isLicensed,
	);
	const { revampedBpqaShownAt } = deserializeState(data);
	const shownAtWithinLastWeek = isWithinLastWeek(revampedBpqaShownAt);

	if (!isLicensed) {
		return { showNewUserTemplates: false, loading: false };
	}

	if (loading) {
		return { showNewUserTemplates: false, loading: true };
	}

	if (error) {
		return { showNewUserTemplates: false, loading: false, error };
	}

	return {
		showNewUserTemplates: shownAtWithinLastWeek,
		loading: false,
	};
};
